<div class="container-fluid">
  <div class="row">

    <div class="col-md-12">
      <div class="card ">
        <div class="card-header card-header-success card-header-icon">
          <div class="card-icon">
            <i class="material-icons">library_books</i>
            <span class="add-announce-title">Modifier une Annonce</span>
          </div>
        </div>
        <hr>
        <p class="text-center"><button class="btn btn-primary" (click)="n_router.routeTo('intotst/' + announce.id, 'dashboard')">Edit 360 Photo</button></p>
        <hr>
        <div class="card-body ">
          <form (ngSubmit)="form.valid && this.requiredImages.valid && updateAnnounce();" #form="ngForm">

            <div class="container">

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label"> Titre de l'annonce <strong style="color: red">*</strong> :</label>
                    <br>
                    <input type="text"
                           class="form-control" id="announce-title"
                           placeholder="titre" [(ngModel)]="announce.title"
                           ngModel
                           name="title"
                           required
                           maxlength="100"
                           #title="ngModel"
                    >
                    <span class="text-danger" *ngIf="!title.valid && title.touched || form.submitted && !title.valid">Le titre est obligatoire !</span>
                    <span class="text-danger" id="announce-title-error"></span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="type" class="bmd-label">Type <strong style="color: red">*</strong> : </label>
                    <div class="control-group" id="type">
                      <label class="control control--radio">Maison
                        <input type="radio" name="radio" value="maison"
                               id="maison"  [(ngModel)]="announce.type"
                               ngModel
                               #type="ngModel"
                               required
                               [checked]="true"
                        />

                        <div class="control__indicator"></div>
                      </label>
                      <label class="control control--radio">Appartement
                        <input type="radio" name="radio" value="appartement" id="appartement" [(ngModel)]="announce.type" required/>
                        <div class="control__indicator"></div>
                      </label>
                      <label class="control control--radio">Surface
                        <input type="radio" name="radio" value="surface" id="surface" [(ngModel)]="announce.type" required />
                        <div class="control__indicator"></div>
                      </label>
                    </div>
                    <span class="text-danger" *ngIf="!type.valid && type.touched || form.submitted && !type.valid">Le type est obligatoire !</span>
                    <span class="text-danger" id="announce-type-error"></span>
                  </div>
                </div>
              </div>




              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description" class="bmd-label">Description <strong style="color: red">*</strong> : </label>
                    <br>
                    <textarea id="description" cols="30" rows="10" class="form-control"
                              name="description" [(ngModel)]="announce.description"
                              placeholder="Ensoleillé toute la journée ..."
                              ngModel
                              #description="ngModel"
                              required
                              [maxLength]="100000"
                    ></textarea>
                    <span class="text-danger" *ngIf="!description.valid && description.touched || form.submitted && !description.valid">La description est obligatoire !</span>
                    <span class="text-danger" id="announce-description-error"></span>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="price" class="bmd-label">Prix <strong style="color: red">*</strong> : </label>
                    <br>
                    <input type="number" class="form-control" id="price"
                           name="price" [(ngModel)]="announce.price"
                           ngModel
                           #price="ngModel"
                           required
                           min="0"
                    >
                    <span class="text-danger" *ngIf="!price.valid && price.touched || form.submitted && !price.valid">Le prix est obligatoire !</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="status" class="bmd-label">Status <strong style="color: red">*</strong> : </label>
                    <br>
                    <input type="number" class="form-control" id="status"
                           name="status" [(ngModel)]="announce.status"
                           ngModel
                           #status="ngModel"
                           required
                    >
                    <span class="text-danger" *ngIf="!status.valid && status.touched || form.submitted && !status.valid">Le status est obligatoire !</span>
                    <span class="text-danger" id="announce-status-error"></span>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="address" class="bmd-label">Adresse <strong style="color: red">*</strong> : </label>
                    <br>
                    <input type="text" class="form-control" id="address"
                           name="address" [(ngModel)]="announce.address"
                           ngModel
                           #address="ngModel"
                           required
                    >
                    <span class="text-danger" *ngIf="!address.valid && address.touched || form.submitted && !address.valid">L'adresse est obligatoire !</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="city" class="bmd-label">Ville <strong style="color: red">*</strong> : </label>
                    <br><br>
                    <select class="form-control" id="city"
                            name="city" [(ngModel)]="announce.city"
                            ngModel
                            #city="ngModel"
                            required
                    >
                      <option value="" selected>-- Choisissez la ville --</option>
                      <option *ngFor="let city of cities">{{city}}</option>
                    </select>
                    <span class="text-danger" *ngIf="!city.valid && city.touched || form.submitted && !city.valid">La ville est obligatoire !</span>
                    <span class="text-danger" id="announce-city-error"></span>
                  </div>
                </div>
              </div>



              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="mapPosition" class="bmd-label">Localisation : </label>
                    <br>
                    <input type="number" class="form-control" id="mapPosition"
                           name="localisation" [(ngModel)]="announce.position_map">
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="rent" class="bmd-label">Vous cherchez à vendre ou louer ? <strong style="color: red">*</strong> : </label>
                    <select name="rent" id="rent" class="form-control rent"
                            [(ngModel)]="announce.rent"
                            ngModel
                            #rent="ngModel"
                            required
                    >
                      <option value="" selected>-- Choisissez ici --</option>
                      <option value="Location">Location</option>
                      <option value="Vente">Vente</option>
                    </select>
                    <span class="text-danger" *ngIf="!rent.valid && rent.touched || form.submitted && !rent.valid"> Précisez une option !</span>
                    <span class="text-danger" id="announce-rent-error"></span>
                  </div>
                </div>
              </div>
              <br><br>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="groundSurface" class="bmd-label">Surface ( en m² ) <strong style="color: red">*</strong> : </label>
                    <br>
                    <input type="number" class="form-control" id="groundSurface"
                           name="groundSurface" [(ngModel)]="announce.surface"
                           ngModel
                           #groundSurface="ngModel"
                           required
                           min="0"
                    >
                    <span class="text-danger" *ngIf="!groundSurface.valid && groundSurface.touched || form.submitted && !groundSurface.valid">La surface est obligatoire !</span>
                    <span class="text-danger" id="announce-surface-error"></span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="pieces" class="bmd-label">
                      Nombre de piéces: </label>
                    <br>
                    <input type="number" class="form-control" id="pieces"
                           name="pieces" [(ngModel)]="announce.pieces"
                           min="0"
                    >
                    <span class="text-danger" id="announce-pieces-error"></span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="rooms" class="bmd-label">

                      Nombre de chambres <strong style="color: red">*</strong> : </label>
                    <br>
                    <input type="number" class="form-control" id="rooms"
                           name="rooms" [(ngModel)]="announce.rooms"
                           ngModel
                           #rooms="ngModel"
                           required
                           min="0"
                    >
                    <span class="text-danger" *ngIf="!rooms.valid && rooms.touched || form.submitted && !rooms.valid">Le nombre de chambres est obligatoire !</span>
                    <span class="text-danger" id="announce-rooms-error"></span>
                  </div>
                </div>
              </div>

              <br><br>
              <div class="row">
                <div class="col-md-12">
                  <app-announce-images [control]="form"></app-announce-images>
                </div>
              </div>
            </div>

            <div class="d-flex flex-row justify-content-center">
              <button class="btn btn-fill btn-success" type="submit"><i class="fa fa-check" aria-hidden="true"></i> Valider</button>
            </div>

          </form>
        </div>
      </div>
    </div>

  </div>
</div>
